import React from "react";

import { Locale } from "../lib/i18n/i18n_provider";
import { LocaleOption, localesByLanguage } from "./locale_data";
import { Picker } from "./picker";
import { useAnalytics } from "../lib/analytics/analytics";

interface LocalePickerProps {
  locale: Locale;
  localeOptions: LocaleOption[];
  onChangeLocale: (locale: Locale) => void;
}

export function LocalePicker(props: LocalePickerProps) {
  const { locale, localeOptions, onChangeLocale } = props;
  const analytics = useAnalytics();

  return (
    <Picker
      options={localeOptions}
      value={locale.languageTag}
      icon="globe"
      onChange={(language) => {
        onChangeLocale(localesByLanguage[language]);

        analytics.event(
          "Language Select Click",
          {
            Language: language,
            Source: "WL",
          },
          { onlyProviders: ["mixpanel", "customerio"] }
        );
      }}
    />
  );
}
